import { config } from "~/lib/config"

type HubSpotCommand = [string, ...unknown[]]

declare global {
  interface Window {
    _hsq?: HubSpotCommand[]
  }
}

/**
 * Ties the HubSpot visitor cookie (shared on `.backflip.com`) to the contact.
 * `_hsq` is a queue, so pushes before the script loads are replayed. HubSpot
 * only sends `identify` with the next page view, hence the `trackPageView`.
 */
export const identifyHubSpotUser = (email: string): void => {
  if (!config.env.hubspotPortalId) return
  const hsq = (window._hsq = window._hsq ?? [])
  hsq.push(["identify", { email }])
  hsq.push(["trackPageView"])
}
